import { useQueries } from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';
import { FileItem, FolderItem } from 'api/types';

interface UseFilesAndFoldersQueryParams {
  categoryId?: string;
  folderId?: string;
  q?: string;
}

interface UseFilesAndFoldersQueryReturn {
  files: FileItem[];
  folders: FolderItem[];
  isLoading: boolean;
}

export function useFilesAndFoldersQuery({
  categoryId,
  folderId,
  q,
}: UseFilesAndFoldersQueryParams): UseFilesAndFoldersQueryReturn {
  const file_params = {
    ...(categoryId && { category_id: categoryId }),
    ...(folderId && { folder_id: folderId }),
    ...(q && { q }),
  };

  const folder_params = {
    ...(categoryId && { category_id: categoryId }),
    ...(folderId && { parent_id: folderId }),
  };

  const [filesQuery, foldersQuery] = useQueries({
    queries: [
      {
        queryKey: ['files', file_params],
        queryFn: () => API_HANDLERS.FILES.GET_LIST(file_params),
        enabled: !!categoryId || !!q,
        refetchOnMount: 'always' as const,
      },
      {
        queryKey: ['folders', folder_params],
        queryFn: () => API_HANDLERS.FOLDERS.GET_LIST(folder_params),
        enabled: !!categoryId,
        refetchOnMount: 'always' as const,
      },
    ],
  });

  return {
    files: filesQuery.data?.data?.data ?? [],
    folders: foldersQuery.data?.data ?? [],
    isLoading: !!categoryId && (filesQuery.isLoading || foldersQuery.isLoading),
  };
}
